define([
    "jquery",
    "components/modal",
    "core/urls",
    "components/dropdown",
    "components/fake-progress",
    "core/iterate",
    'components/request-time-manager',
    "core/utilities",   
    "components/selectize",
], function (
    $,
    modal,
    urls,
    DD,
    FakeProgress,
    iterate,
    requestTM,  
    utilities,
) {
    var nodes = {
        modal: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".create-survey-s1"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ],
        },
        connectionErrorModal: document.querySelector(".modal-template-error_js"),
        projectErrorModal: document.querySelector(".modal-template-no-projects"),
        form: document.querySelector("#create_survey_js"),
        nameInputSingle: document.querySelector(".single-survey-inputs .survey-name-input"),
        nameErrorSingle: document.querySelector(".single-survey-inputs .survey-name-error"),
        nameInputGlobal: document.querySelector(".global-inputs .survey-name-input"),
        nameErrorGlobal: document.querySelector(".global-inputs .survey-name-error"),
        companySelectorWrap: document.querySelector(".company-selector"),
        companySelector: document.querySelector(".company-selector select"),
        projectLabelWrap: document.querySelector(".project-label-wrap"),
        projectSelectorWrap: document.querySelector(".project-selector"),
        projectSelector: document.querySelector(".project-selector select"),
        languageSelectorWrap: document.querySelector(".language-selector"),
        languageSelectorWrap2: document.querySelector(".language-selector2"),
        phaseStatusToggleWrap: document.querySelector(".single-survey-inputs .phase-and-status-toggle-wrap"),
        phaseStatusToggle: document.querySelector(".single-survey-inputs #phase_and_status_toggle"),
        projectStatusToggle: document.querySelector(".single-survey-inputs #project_status_toggle"),
        projectStatusToggleSingle: document.querySelector(".single-survey-inputs #project_status_toggle_single"),
        projectStatusSelectSingle: document.querySelector(".single-survey-inputs select.project-status"),
        projectStatusSelectGlobal: document.querySelector(".global-inputs select.project-status"),
        projectStatusWrapSingle: document.querySelector(".single-survey-inputs .project-status-wrapper"),
        projectStatusWrapGlobal: document.querySelector(".global-inputs .project-status-wrapper"),
        resendFrequencyWrap: document.querySelector(".resend-frequency-wrapper"),
        resendFrequencySelector: document.querySelector(".resend-frequency-wrapper select"),
        projectPhaseSelect: document.querySelector("select#project_phase"),
        projectPhaseWrapper: document.querySelector(".project-phase-wrapper"),
        projectTypesToggle: document.querySelector("#project_types_toggle"),
        projectTypesToggleWrap: document.querySelector(".project-types-toggle-wrap"),
        projectTypesSelect: document.querySelector("select#project_types"),
        projectTypesError: document.querySelector(".project-types-error"),
        projectTypesWrapper: document.querySelector(".project-types-wrapper"),
        phaseStatusSelect: document.querySelector("select.phase-status"),
        phaseStatusWrap: document.querySelector(".phase-status-wrapper"),
        loaderElement: document.querySelector(".marketing-loader"),
        loaderHint: document.querySelector(".marketing-loader .loader-bar-wrap_hint"),
        ruleList: document.querySelector(".projects-rules-list_js"),
        modalContent: document.querySelector(".modal-template-welcome_js"),
        submit: document.querySelector(".projects-survey-submit_js"),
        scheduleOptions: document.querySelector(".schedule-options"),
        scheduleError: document.querySelector(".schedule-options .error"),
        surveyConditions: document.querySelector(".survey-conditions"),
    };

    let dataTimeManager = new requestTM();
    let project =  {
        id: '',
        phasesFetched: false,
    };

    let selectedCompany = {};
    let apiError = false;

    // this will be true if Step 1 data has already been saved 
    let useSavedData = Boolean(nodes.nameInputSingle.value);

    let projectPhasesStatusesCollected = false;

    let selectizePhase = $("#project_phase")[0].selectize;
    let selectizeProjectTypes = $("#project_types")[0].selectize;
    let DDCompanySelector;
    let DDProjectSelector;
    let DDProjectStatusSingle;
    let DDProjectStatusGlobal;

    let isGlobalDataAttr = document.querySelector(".create-survey-s1").dataset.isGlobal;
    let isGlobal = isGlobalDataAttr === "True" || isGlobalDataAttr === '' ? true : false;

    let validationConfigsSingle = [
        {
            input: nodes.nameInputSingle,
            errorNode: nodes.nameErrorSingle,
            validations: ["alphaNumeric", "hasValue"],
        },
    ];

    let validationConfigsGlobal = [
        {
            input: nodes.nameInputGlobal,
            errorNode: nodes.nameErrorGlobal,
            validations: ["alphaNumeric", "hasValue"],
        },
    ];

    let taskId = nodes.form.getAttribute("data-task-id");

    nodes.loaderHint.innerText = "Retrieving your project data. Please wait.";

    let loadingScreen = new FakeProgress(
        document.querySelector(".marketing-loader .loader-bar-wrap-bar")
    );

    let createdModal = modal.create(nodes.modal, function (el) {});
    let createdModalAPIError = modal.create(nodes.modal, function (el) {
        setTimeout(() => {
            if(apiError) {
                window.location = urls["projects:survey_manager"]();
            }
        }, 200)
        
    });
    let modalTemplate = document.querySelector(".modal-template-leave_js");
    let hrefs = document.querySelectorAll("a[href]"); 
    let surveyId = document.querySelector("[data-survey-id]").dataset.surveyId;

    let hrefsToIgnore = [
        urls['projects:start_projects_survey'](surveyId),
        urls['projects:start_projects_survey_s2'](surveyId),
        urls['projects:start_projects_survey_s3'](surveyId),
        urls['projects:start_projects_survey_s4'](surveyId),
    ];

    function exitWarningGeneric() {
        iterate(hrefs, function (node) {
            node.addEventListener("click", (event) => {
                utilities.confirmPageExit(
                    event,
                    createdModal,
                    modalTemplate,
                    null,
                    hrefsToIgnore
                );
            });
        });
    }

    let enableSurveyToggle = () => {
        let surveyToggle = document.querySelector(".slide-toggle-wrapper input");
        let labelGlobal = document.querySelector(".slide-toggle-wrapper .toggle-label.left");
        let labelSingle = document.querySelector(".slide-toggle-wrapper .toggle-label.right");
        let globalInputs = document.querySelector("#create_survey_js .global-inputs");
        let singleSurveyInputs = document.querySelector("#create_survey_js .single-survey-inputs");

        let updateForm = () => {
            if(isGlobal) {
                globalInputs.classList.remove("hide");
                singleSurveyInputs.classList.add("hide");
            } else {
                globalInputs.classList.add("hide");
                singleSurveyInputs.classList.remove("hide");
            }
        }

        if(surveyToggle) {
            surveyToggle.addEventListener("change", (event) => {
                if(event.target.checked) {
                    labelGlobal.classList.add("active");
                    labelSingle.classList.remove("active");
                    isGlobal = true;
                    updateForm();
                } else {
                    labelGlobal.classList.remove("active");
                    labelSingle.classList.add("active");
                    isGlobal = false;
                    updateForm();
                }
            })
        }

        updateForm();
    }

    let createSelectOption = (data, selectedValue) => {
        let newOption = document.createElement("option");
        newOption.setAttribute("value", data.id);

        if (selectedValue == data.id){
            newOption.setAttribute("selected", "selected");
        }
        newOption.innerText = data.name;
        
        return newOption;
    }

    let populateProjectStatuses = (statuses) => {
        let selectedValue = nodes.projectStatusSelectSingle.dataset.value;

        statuses.forEach(status => {
            nodes.projectStatusSelectSingle.appendChild(createSelectOption(status, selectedValue));
            nodes.projectStatusSelectGlobal.appendChild(createSelectOption(status, selectedValue));
        })
        
        DDProjectStatusSingle = DD(nodes.projectStatusWrapSingle, (selectedValue) => {});
        DDProjectStatusGlobal = DD(nodes.projectStatusWrapGlobal, (selectedValue) => {});
        

        if (nodes.projectSelector.dataset.value && !selectedValue){
            nodes.projectStatusWrapSingle.parentNode.classList.add("disabled");
        }
    }

    let populateProjectTypes = (types) => {
        let selectedOptions = nodes.projectTypesSelect.dataset.value;

        if (selectedOptions) {
            selectedOptions = JSON.parse(selectedOptions);
        }

        selectizeProjectTypes.clear();
        selectizeProjectTypes.clearOptions();

        types.forEach(type => {
            selectizeProjectTypes.addOption({value: type.id, text: type.name});
        });

        if (selectedOptions && selectedOptions.length) {
            selectizeProjectTypes.setValue(selectedOptions);
        }
    }

    let populatePhaseStatuses = (statuses) => {        
        DDPhaseStatus.removeOption("placeholder", "—");

        statuses.forEach(status => {
            DDPhaseStatus.addOption(status.id, status.name)
        })  

        let selectedValue = nodes.phaseStatusSelect.dataset.value;

        if(selectedValue) {
            DDPhaseStatus.chooseOption(selectedValue)
        }
    }

    let getProjectPhaseStatus = () => {

        let xhr = new XMLHttpRequest();
        let url = urls["projects:project_phase_statuses"]();
        xhr.open("GET", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onreadystatechange = function () {
            if(xhr.status === 403) { // api permissions error
                data = {success: false};

                // phases API error
                resetPhaseAndStatus();
                nodes.scheduleError.innerHTML = "We're currently experiencing a connectivity issue and are unable to load your Project Phase Statuses. Please allow access to the Project Phase Status table in ConnectWise PSA Tables Setup security module."
                nodes.scheduleError.classList.remove("hide");

                loadingScreen.loadFinish();
                dataTimeManager.abort();
                return;
            }

            if(xhr.readyState == 4 && xhr.status == 200) {

                project.phasesFetched = true;

                let data = {};
            
                try {
                    data = JSON.parse(xhr.responseText);
                } catch (e) {
                    data = {success: false};
                }
                
                if (data && data.length) {
                    populatePhaseStatuses(data)     
                    projectPhasesStatusesCollected = true;            
                } else {
                    // no phase statuses are available
                    resetPhaseAndStatus();
                    nodes.scheduleError.innerText = "There are no phases statuses available for this project."
                    nodes.scheduleError.classList.remove("hide");

                    nodes.loaderElement.classList.add("disabled");
                    loadingScreen.loadFinish();
                }
            }

            nodes.loaderElement.classList.add("disabled");
            loadingScreen.loadFinish();
        }

        xhr.send();
    }

    let getProjectPhases = (isPageLoad) => { // this needs to be made as a separate call once we have project ID
        
        nodes.scheduleError.classList.add("hide");

        // check for saved data
        let selectedOptions = nodes.projectPhaseSelect.dataset.value;
        if(selectedOptions && project.id === nodes.projectSelector.dataset.value) {
            selectedOptions = JSON.parse(nodes.projectPhaseSelect.dataset.value);
        }

        if(!isPageLoad) {
            // open loading screen if not already open at page load
            loadingScreen.reset();
            nodes.loaderElement.classList.remove("disabled");
            loadingScreen.startLoading(15);
        };          

        let xhr = new XMLHttpRequest();
        let url = urls["projects:project_phases"](project.id);
        xhr.open("GET", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onreadystatechange = function () {
            if(xhr.status === 403) { // api permissions error
                data = {success: false};

                // phases API error
                resetPhaseAndStatus();
                nodes.scheduleError.innerHTML = "We're experiencing a connectivity issue and are unable to load your Project Phases. Please provide inquirly level access to the <strong>Project Phase</strong> security role in ConnectWise PSA"
                nodes.scheduleError.classList.remove("hide");

                loadingScreen.loadFinish();
                dataTimeManager.abort();
                return;
            }

            if(xhr.readyState == 4 && xhr.status == 200) {

                project.phasesFetched = true;

                let data = {};
            
                try {
                    data = JSON.parse(xhr.responseText);
                } catch (e) {
                    data = {success: false};
                }
                
                if (data && data.length) {
                    selectizePhase.clear();
                    selectizePhase.clearOptions();
                    
                    data.forEach(phase => {
                        selectizePhase.addOption({value: phase.id, text: phase.name});
                    })
                    
                    if(selectedOptions) {
                        selectizePhase.setValue(selectedOptions)
                    }
                    
                    if(!projectPhasesStatusesCollected) {
                        getProjectPhaseStatus();
                    } else {
                        nodes.loaderElement.classList.add("disabled");
                        loadingScreen.loadFinish();
                    }
                    
                } else {
                    // no phases are available
                    resetPhaseAndStatus();
                    nodes.scheduleError.innerText = "There are no phases available for this project."
                    nodes.scheduleError.classList.remove("hide");

                    nodes.loaderElement.classList.add("disabled");
                    loadingScreen.loadFinish();
                }
            }
        }
        xhr.send();
    }

    let resetPhaseAndStatus = () => {
        nodes.phaseStatusToggle.checked = false;
        nodes.phaseStatusToggleWrap.querySelector(".description").classList.add("disabled");
        selectizePhase.clear();
        selectizePhase.clearOptions();
        nodes.scheduleError.classList.add('hide');
        project.phasesFetched = false;
    }

    let populateProjects = (projects) => {
        // remove previous project options if present
        document.querySelector(".project-selector select").innerHTML = '';
        let projectsMockSelect = document.querySelector(".project-selector .mock-select");
        
        if(projectsMockSelect) {
            projectsMockSelect.remove();
            document.querySelector(".project-selector .mock-options").remove();
        }

        let val = nodes.projectSelector.dataset.value;

        // inject new options
        projects.forEach(project => {
            nodes.projectSelector.appendChild(createSelectOption(project, val));
        })

        if(val && useSavedData) {
            project.id = val
            useSavedData = false;
        } else {
            project.id = projects[0].id;
        }

        DDProjectSelector = DD(nodes.projectSelectorWrap, (val) => {
            if(project.id !== val) {
                project.id = val;
                resetPhaseAndStatus();
            }
        });

        nodes.projectLabelWrap.classList.remove("disabled");
        nodes.scheduleOptions.classList.remove("hide");
    }

    let populateCompanies = (companies) => {
        let savedCompanyId = nodes.companySelector.dataset.value;
        let savedCompany = null;

        companies.forEach(company => {
            let newOption = document.createElement("option");
            newOption.setAttribute("value", company.id);
            newOption.dataset.projects = JSON.stringify(company.projects);

            if (savedCompanyId === company.id){
                savedCompany = company;
                newOption.setAttribute('selected', 'selected');
            }
            newOption.innerText = company.name;
            nodes.companySelector.appendChild(newOption)
        });

        DDCompanySelector = DD(nodes.companySelectorWrap, (val, id, selectedOption) => {
            useSavedData = false;
            let associatedProjects = JSON.parse(selectedOption.dataset.projects)
            project.id = associatedProjects[0].id;
            populateProjects(associatedProjects);
            resetPhaseAndStatus();
        });

        if(useSavedData && !isGlobal) {
            populateProjects(savedCompany.projects);
        } else {
            populateProjects(companies[Object.keys(companies)[0]].projects);
        }
    }

    let getInitialData = () => {
        dataTimeManager.start((error) => {
            nodes.loaderElement.classList.add("disabled");
            loadingScreen.loadFinish();
        });

        loadingScreen.reset();
        nodes.loaderElement.classList.remove("disabled");
        loadingScreen.startLoading(15);

        function request() {
            let xhr = new XMLHttpRequest();
            let url = urls['task_check'](taskId);

            xhr.open("GET", url, true);
            dataTimeManager.addXHR(xhr);
            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.onreadystatechange = function () {
                let data = {};
                try {
                    data = JSON.parse(xhr.responseText);
                } catch (e) {
                    data = {success: false};
                }

                switch (true) {
                    case xhr.status === 500:
                        nodes.loaderElement.classList.add("disabled");
                        loadingScreen.loadFinish();
                        dataTimeManager.abort();
                        break;

                    case xhr.status === 0:
                        data = {success: false};
                        return;
                    
                    case xhr.status === 403:
                        data = {success: false};
                        apiError = true;
                        createdModalAPIError.open({
                            class: "error-modal",
                            content: nodes.connectionErrorModal.innerHTML,
                            title: ""
                        });
                        loadingScreen.loadFinish();
                        dataTimeManager.abort();
                        return;

                    case xhr.status !== 200:
                        data = {success: false};
                        break;
                }

                if (data.successful) {      
                    if (Boolean(data.response.failed_endpoints)) {
                        createdModal.open({
                            class: "error-modal",
                            content: nodes.connectionErrorModal.innerHTML,
                            title: ""
                        }, function (el) {
                            let failedEndpointsWrap = document.querySelector(".sb-modal__content .failed-endpoints-wrap");
                            let failedEndpointsElement = document.querySelector(".failed-endpoints");

                            failedEndpointsWrap.classList.remove("hide");

                            data.response.failed_endpoints.forEach(endpoint => {
                                failedEndpointsElement.innerHTML += `<span class="endpoint">${endpoint}</span>`
                            })
                            document.querySelector(".modal-bg_js").addEventListener("click", () => {
                                window.location = urls["projects:survey_manager"]();
                            });
                        });

                        data = {success: false};
                        loadingScreen.loadFinish();
                        dataTimeManager.abort();
                        return;

                    } else if(data.response.companies.length === 0) { // customer has no projects
                        data = {success: false};
                        createdModal.open({
                            class: "error-modal",
                            content: nodes.projectErrorModal.innerHTML,
                            title: ""
                        }, function (el) {
                            document.querySelector(".modal-bg_js").addEventListener("click", () => {
                                window.location = urls["projects:survey_manager"]();
                            });
                        });
                        loadingScreen.loadFinish();
                        dataTimeManager.abort();
                    } else {
                        // pull phase data if the toggle is saved as 'on'
                        if(nodes.phaseStatusToggle.checked) {
                            project.id = nodes.projectSelector.getAttribute("data-value");
                            getProjectPhases(true);
                            nodes.phaseStatusToggleWrap.querySelector(".description").classList.remove("disabled");
                        } else {
                            // otherwise close loader
                            nodes.loaderElement.classList.add("disabled");
                            loadingScreen.loadFinish();
                        }

                        dataTimeManager.abort({success: true});

                        populateCompanies(data.response.companies);
                        populateProjectStatuses(data.response.project_statuses);
                        if (data.response.project_types) {
                            populateProjectTypes(data.response.project_types);
                        }
                        enableSurveyToggle();
                    }
                } else {
                    if(data.done) {
                        createdModal.open({
                            class: "generic-error-modal",
                            content: `<div class="body">Something went wrong. Please try again</div>`,
                            title: "Problem loading page"
                        }, function (el) {
                            document.querySelector(".modal-bg_js").addEventListener("click", () => {
                                window.location = urls["projects:survey_manager"]();
                            });
                        });
                        loadingScreen.loadFinish();
                        dataTimeManager.abort();
                    }                    
                }
            };
            xhr.send();
        };
        dataTimeManager.interval(request);
    }

    let validateScheduling = () => {
        let isValid = true;
        let errorElement = document.querySelector(".schedule-error");
        errorElement.classList.add("hide");

        // scheduling
        if(nodes.projectStatusToggleSingle.checked === false && nodes.phaseStatusToggle.checked === false) {
            nodes.scheduleError.innerText = "Please select at least one scheduling option.";
            nodes.scheduleError.classList.remove("hide");
            isValid = false;
        }

        if(nodes.phaseStatusToggle.checked === true) {
            let projectPhaseMultiSelect = document.querySelector(".project-phase-wrapper .selectize-input");
            if(!projectPhaseMultiSelect.classList.contains("has-items")) {
                nodes.scheduleError.innerText = "Please select at least one project phase, or disable this option.";
                nodes.scheduleError.classList.remove("hide");
                isValid = false;
            }
        }

        return isValid;
    }

    let onSave = () => {
        
        let validationConfig = isGlobal ? [{...validationConfigsGlobal}[0]] : validationConfigsSingle;

        if (isGlobal && nodes.projectTypesToggle.checked) {
            validationConfig.push({
                input: nodes.projectTypesSelect,
                errorNode: nodes.projectTypesError,
                validations: ["hasValue"],
            });
        }

        let formIsValid = utilities.validateForm(validationConfig);

        let disableInputs = (parentClass) => {
            let inputs = document.querySelectorAll(`.${parentClass} input, .${parentClass} select`);
            inputs.forEach((input) => {
                input.disabled = true;
            })
        }

        let enableInputs = (parentClass) => {
            let inputs = document.querySelectorAll(`.${parentClass} input, .${parentClass} select`);
            inputs.forEach((input) => {
                input.disabled = false;
            })
        }

        if(formIsValid) {
            if (!nodes.projectTypesToggle.checked) {
                selectizeProjectTypes.clear();
                nodes.projectTypesSelect.disabled = true;
            }

            if(!isGlobal) {
                let schedulingValid = validateScheduling();
                if(schedulingValid) {
                    disableInputs("global-inputs");
                    enableInputs("single-survey-inputs");
                    return true;
                }
            } else {
                disableInputs("single-survey-inputs");
                enableInputs("global-inputs");
                return true;
            }
        }
        
        return false;
    }

    let createEventListeners = () => {
        // toggles
        let toggles = document.querySelectorAll(".toggle-wrapper input");
        toggles.forEach(toggle => {
            let toggleId = toggle.getAttribute("id");
            let descriptionElement =  document.querySelector(`.description[data-toggle-id='${toggleId}']`);
            toggle.addEventListener("change", () => {
                toggle.checked ? descriptionElement.classList.remove("disabled") : descriptionElement.classList.add("disabled");

                if(toggleId === 'phase_and_status_toggle') {
                    if(toggle.checked && project.phasesFetched === false) getProjectPhases();
                }
            })
        })


        nodes.projectTypesToggle.addEventListener("change", () => {
            if(!nodes.projectTypesToggle.checked && nodes.projectTypesWrapper.querySelector(".danger")) {
                nodes.projectTypesError.classList.add("hide");
                nodes.projectTypesWrapper.querySelector(".danger").classList.remove("danger");
            }
        })

        nodes.submit.addEventListener("click", (event) => {
            event.preventDefault();
            let validateSave = onSave();

            if(validateSave) {
                nodes.form.submit();
            }
        })

        selectizePhase.on("change", value => {
            let statusText = document.querySelector(".status-context");
            
            if(value.length > 1) {
                statusText.innerHTML = "phase statuses are";
            } else {
                statusText.innerHTML = "phase status is";
            }

            let errorElement = document.querySelector(".schedule-error");
            errorElement.classList.add("hide");
        })
    }


    return {
        init: function () {

            getInitialData();
            createEventListeners();
            exitWarningGeneric();

            DDPhaseStatus = DD(nodes.phaseStatusWrap, (selectedValue) => {});
            DDLanguage = DD(nodes.languageSelectorWrap, (selectedValue) => {});
            DDLanguage2 = DD(nodes.languageSelectorWrap2, (selectedValue) => {});
            DDFrequencySelector = DD(nodes.resendFrequencyWrap, (val) => {});

            if(nodes.resendFrequencySelector.dataset.savedValue) {
                DDFrequencySelector.chooseOption(nodes.resendFrequencySelector.dataset.savedValue);
            }

            nodes.ruleList = document.querySelector(".projects-rules-list_js");

            iterate(hrefs, function (node) {
                node.addEventListener("click", event => {
                    utilities.confirmPageExit(event, createdModal, modalTemplate, null, hrefsToIgnore);
                });
            });
        },
    };
});